import { RegisteredComponent } from "@builder.io/sdk-react";
import { textualFormConfig } from "./textualFormConfigs";
import { generalFormConfig } from "./generalFormConfig";
import { DLD_FIELD, DLT_FIELD, HREF_FIELD } from "../../commonFields";

export const searchInputBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Search input",
  description:
    "The following state variables are expected: [name] for handling the value of the input.",
  canHaveChildren: false,
  noWrap: true,
  defaultStyles: {
    width: "100%",
    flexShrink: "1",
    outline: "none",
  },
  shouldReceiveBuilderProps: {
    builderContext: true,
  },
  inputs: [
    {
      name: "suggestions",
      type: "list",
      subFields: [
        {
          name: "type",
          type: "enum",
          enum: ["search", "link"],
          localized: false,
          required: true,
          defaultValue: "search",
        },
        {
          name: "label",
          type: "string",
          localized: true,
          showIf: (options) => options.get("type") === "search",
        },
        {
          name: "value",
          type: "string",
          localized: false,
          showIf: (options) => options.get("type") === "search",
        },
        {
          name: "disabled",
          type: "boolean",
          localized: false,
          defaultValue: false,
          showIf: (options) => options.get("type") === "search",
        },
        {
          name: "title",
          type: "text",
          localized: true,
          required: true,
          showIf: (options) => options.get("type") === "link",
        },
        { ...HREF_FIELD, showIf: (options) => options.get("type") === "link" },
        { ...DLD_FIELD, showIf: (options) => options.get("type") === "link" },
        { ...DLT_FIELD, showIf: (options) => options.get("type") === "link" },
      ],
      defaultValue: [],
    },
    {
      name: "value",
      type: "string",
      localized: false,
    },
    {
      name: "onInitialize",
      type: "javascript",
      localized: false,
    },
    {
      name: "onChange",
      type: "javascript",
      localized: false,
    },
    {
      name: "onSearch",
      type: "javascript",
      localized: false,
    },
    ...(generalFormConfig ?? []),
    ...(textualFormConfig ?? []),
  ],
};
